<template>
  <div class="top">
    <Kv></Kv>
    <steps :step="1" />
    <div class="contents">
      <Step1 :searchNumber="itemArray.length"></Step1>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Step1 from "../model/top/Step1.vue";
import Kv from "../model/top/Kv.vue";
import { withinPriceRange } from "../../modules/withinPriceRange";
import Steps from "../model/common/Steps.vue";
export default {
  name: "Top",
  components: { Step1, Kv, Steps },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters("selectedFormIds", [
      "selectedLists",
      "selectedCategory",
      "isListChecked",
      "isCategorySelected",
    ]),
    ...mapGetters("jsonData", ["tables", "forms"]),
    itemArray() {
      if (!this.isCategorySelected) return [];
      const categoryFilteredItems = this.filterCategory(this.items);
      return this.filterItem(categoryFilteredItems);
    },
  },
  methods: {
    removeSelectedItem(janCode) {
      this.$store.dispatch("product/removeSelectedProductIds", {
        value: janCode,
      });
    },
    /**
     * 商品の配列を条件でフィルタリングした結果を返す
     */
    filterItem(itemArray) {
      const { brand_names, kinou_search, price_range, seibun, worries_some } =
        this.selectedLists;
      let filteredItem = [];
      filteredItem = this.matchFilter(
        brand_names,
        itemArray,
        "brand_name",
        "brand_names"
      );
      filteredItem = this.matchFilter(
        worries_some,
        filteredItem,
        "worries_some"
      );
      filteredItem = this.matchFilter(
        kinou_search,
        filteredItem,
        "kinou_search"
      );
      filteredItem = this.matchFilter(seibun, filteredItem, "seibun");
      filteredItem = this.priceRangeFilter(price_range, filteredItem);
      return filteredItem;
    },

    /**
     * 商品カテゴリーでフィルタリングする
     */
    filterCategory(itemArray) {
      const categoryID =
        this.forms.bigan_names[this.selectedCategory].values[0];
      return itemArray.filter((item) => {
        let isMatched = false;
        isMatched = item.bigan_name === categoryID;

        if (!isMatched) this.removeSelectedItem(item.jan_code);
        return isMatched;
      });
    },

    /**
     * マッチするかどうかの条件でフィルタリングする
     * @param {array} condition 条件の値が入った配列
     * @param {array} targetArray フィルタリングをかける商品の配列
     * @param { string } targetKey 商品オブジェクトの中でフィルタリングに使うkeyの名前
     * @param { string } tableKey テーブルオブジェクトの中でフィルタリングに使うkeyの名前
     */
    matchFilter(condition, targetArray, targetKey, tableKey = targetKey) {
      if (condition.length === 0) return targetArray;
      const formData = this.forms[tableKey];
      const conditionValues = condition.flatMap((key) => formData[key].values);
      const newConditionValues = [...new Set(conditionValues)]; // 重複をなくす

      return targetArray.filter((item) => {
        const testValue = item[targetKey];
        let isMatched = false;
        if (Array.isArray(testValue)) {
          isMatched = testValue.some((value) =>
            newConditionValues.includes(value)
          );
        } else {
          isMatched = newConditionValues.includes(testValue);
        }

        // filterによって外される場合はチェックボックスのチェックを消す
        if (!isMatched) this.removeSelectedItem(item.jan_code);

        return isMatched;
      });
    },

    /**
     * 値の幅に収まっているかどうかの条件でフィルタリングする
     * @param {array} condition 条件の値が入った配列
     * @param {array} targetArray フィルタリングをかける商品の配列
     */
    priceRangeFilter(condition, targetArray) {
      if (condition.length === 0) return targetArray;

      const formData = this.forms["price_range"];
      const conditionValues = condition.flatMap((key) => formData[key].values);
      const newConditionValues = [...new Set(conditionValues)];

      /**
       * @type { [number, number][] } 価格の数字の下限と上限が入った配列
       */
      const matchedConditions = newConditionValues.map((key) => {
        return this.tables.price_range[key];
      });

      const matchedItems = targetArray.filter((target) => {
        const targetPrice = target.komi_kkk;

        // memo: １つでも条件に引っかかっていればsomeでtrueが返る
        const isWithinRange = matchedConditions.some((priceRangeArray) => {
          const isInRange = withinPriceRange(priceRangeArray, targetPrice);
          return isInRange;
        });

        // filterによって外される場合はチェックボックスのチェックを消す
        if (!isWithinRange) this.removeSelectedItem(target.jan_code);

        return isWithinRange;
      });
      return matchedItems;
    },
  },
  created() {
    this.$store.dispatch("product/setFixedId", { value: "" });
  },
};
</script>

<style lang="scss" scoped>
.top {
  .contents {
    margin-top: 60px;
    padding-bottom: 20px;
    &-sticky {
      position: sticky;
      bottom: 0;
      left: 0;
      .searchIcon {
        margin-left: auto;
      }
      .nextButton {
      }
    }
  }

  @include media() {
    .contents {
      margin-top: 0;
    }
    .searchIcon {
      right: vw(8);
      bottom: vw(10);
    }
  }
}
</style>
